export default __webpack_public_path__ + "static/media/celebrating.fe73a25a.svg";